/* Zaltify: hide product review widgets only at a confirmed count of zero. */
(function () {
  'use strict';
  if (window.zaltifyReviewVisibilityV3) return;
  window.zaltifyReviewVisibilityV3 = true;
  window.zaltifyEmptyRatingsInitialized = true;

  var summarySelector = '.klaviyo-star-rating-widget, .rating-wrapper';
  var fullSelector = '#klaviyo-product-reviews-wrapper';
  var excludedSelector = '#klaviyo-all-reviews-wrapper, #klaviyo-reviews-carousel-wrapper, .zc-kl-badge, .zc-kl-badge-wrap';
  var countAttributes = ['data-review-count', 'data-review_count', 'data-rating-count'];
  var words = '(?:reviews?|anmeldelser?|bewertung(?:en)?|avis|recension[ei]|reseñas?|arvostel(?:u|ua)|beoordeling(?:en)?|recension(?:er)?)';
  var afterNumber = new RegExp('(?:^|[^\\d.,])([0-9][0-9.,\\s]*)\\s*' + words + '(?=\\s|[).,:;!?]|$)', 'ig');
  var beforeNumber = new RegExp(words + '\\s*[:(]\\s*([0-9][0-9.,\\s]*)', 'ig');
  var noReviews = /^(?:no reviews(?: yet)?|ingen anmeldelser(?: endnu)?|keine bewertungen|aucun avis|nessuna recensione|sin reseñas|ei arvosteluja|geen beoordelingen)[.!]?$/i;
  var pending = false;

  function text(node) {
    return (node ? node.textContent || '' : '').replace(/[\u200B-\u200D\uFEFF]/g, '').replace(/\s+/g, ' ').trim();
  }
  function integer(value) {
    var normalized = String(value == null ? '' : value).trim();
    if (!/^[0-9][0-9\s.,]*$/.test(normalized)) return null;
    return Number(normalized.replace(/[^0-9]/g, ''));
  }
  function countInText(value, numberOnly) {
    var normalized = String(value || '').replace(/[\u200B-\u200D\uFEFF]/g, '').replace(/\s+/g, ' ').trim();
    var counts = [];
    [afterNumber, beforeNumber].forEach(function (pattern) {
      pattern.lastIndex = 0;
      var match;
      while ((match = pattern.exec(normalized))) {
        var count = integer(match[1]);
        if (count !== null) counts.push(count);
      }
    });
    if (counts.length) return Math.max.apply(null, counts);
    if (noReviews.test(normalized)) return 0;
    return numberOnly ? integer(normalized.replace(/^\(|\)$/g, '')) : null;
  }
  function declaredCount(widget) {
    for (var i = 0; i < countAttributes.length; i++) {
      if (!widget.hasAttribute(countAttributes[i])) continue;
      var count = integer(widget.getAttribute(countAttributes[i]));
      if (count !== null) return count;
    }
    return null;
  }
  function summaryCount(widget) {
    var label = widget.querySelector('.kl_reviews__star_rating_widget__label, .rating-count');
    var count = label ? countInText(text(label), true) : null;
    if (count !== null) return count;
    count = declaredCount(widget);
    if (count !== null) return count;
    return countInText(text(widget) + ' ' + (widget.getAttribute('aria-label') || ''), false);
  }
  function mark(element, count) {
    var state = count === null ? 'unknown' : count === 0 ? 'empty' : 'positive';
    if (element.getAttribute('data-zaltify-review-state') !== state) {
      element.setAttribute('data-zaltify-review-state', state);
    }
  }
  function sync() {
    pending = false;
    var main = document.getElementById('MainContent');
    var productPage = !!main && /^product(?:\.|$)/.test(main.getAttribute('data-template') || '');
    var pageCounts = [];
    var blocks = new Set();
    document.querySelectorAll(summarySelector).forEach(function (widget) {
      if (widget.closest(excludedSelector)) return;
      var count = summaryCount(widget);
      mark(widget, count);
      var block = widget.closest('.shopify-app-block');
      if (block && block !== widget) blocks.add(block);
      if (productPage && main.contains(widget) && !widget.closest('product-card, quick-add-component, .product-recommendations, ' + fullSelector) && count !== null) {
        pageCounts.push(count);
      }
    });
    var pageCount = pageCounts.length ? Math.max.apply(null, pageCounts) : null;
    document.querySelectorAll(fullSelector).forEach(function (widget) {
      var count = declaredCount(widget);
      var total = widget.querySelector('[itemprop="reviewCount"]');
      if (count === null && total) count = integer(total.getAttribute('content') || text(total));
      if (count === null && productPage) count = pageCount;
      mark(widget, count);
      var block = widget.closest('.shopify-app-block');
      if (block && block !== widget) blocks.add(block);
    });
    blocks.forEach(function (block) {
      var widgets = Array.from(block.querySelectorAll(summarySelector + ', ' + fullSelector));
      var empty = widgets.length > 0 && widgets.every(function (widget) {
        return widget.getAttribute('data-zaltify-review-state') === 'empty';
      });
      // Only collapse an app block whose content belongs entirely to its widgets.
      var remainder = block.cloneNode(true);
      remainder.querySelectorAll(summarySelector + ', ' + fullSelector + ', script, style, link').forEach(function (node) { node.remove(); });
      var exclusive = text(remainder) === '' && !remainder.querySelector('input, select, button, a, img, video, iframe');
      mark(block, empty && exclusive ? 0 : null);
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(sync);
  }
  function start() {
    sync();
    var observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, {
      childList: true, subtree: true, characterData: true, attributes: true,
      attributeFilter: countAttributes.concat(['aria-label', 'content', 'data-template'])
    });
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
